import YahenLogoMark from './YahenLogoMark';

export default function LogoIcon() {
  return <YahenLogoMark size={32} />;
}
